export class WebhookV1StandardPayloadSnapshotUserProtection {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadSnapshotUserProtectionTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadSnapshotUserProtectionArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadSnapshotUserProtection.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadSnapshotUserProtectionTypeEnum;
(function (WebhookV1StandardPayloadSnapshotUserProtectionTypeEnum) {
    WebhookV1StandardPayloadSnapshotUserProtectionTypeEnum["Protected"] = "SNAPSHOT_USER_PROTECTED";
    WebhookV1StandardPayloadSnapshotUserProtectionTypeEnum["Unprotected"] = "SNAPSHOT_USER_UNPROTECTED";
})(WebhookV1StandardPayloadSnapshotUserProtectionTypeEnum || (WebhookV1StandardPayloadSnapshotUserProtectionTypeEnum = {}));
